import React, { useEffect, useRef, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa6';
import { FiLink } from 'react-icons/fi';
import { copyText, whatsappHref } from '../../utils/share';
import {
  ShareRow,
  ShareLink,
  ShareAction,
  CopiedNote,
} from '../shared/ShareButtons/ShareButtons.styles';
import { ShareBox } from './promoters.styles';

// Enlace de promotor de una actividad: `shareUrl` viene del backend
// (https://bokerhub.com/share/activity/<id>?ref=CODIGO, con Open Graph; nunca
// la URL de la SPA). Solo copiar y WhatsApp: los demás botones de compartir
// quedan fuera de esta fase.
const PromoterShareLinks = ({ url, text }) => {
  const [status, setStatus] = useState('');
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const flash = (message) => {
    setStatus(message);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setStatus(''), 2500);
  };

  const handleCopy = async () => {
    try {
      await copyText(url);
      flash('¡Enlace copiado!');
    } catch (e) {
      flash('No se pudo copiar el enlace');
    }
  };

  if (!url) return null;

  return (
    <ShareBox>
      <span className="url" data-testid="promoter-share-url">{url}</span>
      <ShareRow role="group" aria-label="Compartir tu enlace de promotor">
        <ShareAction type="button" onClick={handleCopy}>
          <FiLink aria-hidden="true" /> Copiar enlace
        </ShareAction>
        <ShareLink
          href={whatsappHref(text, url)}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Compartir tu enlace en WhatsApp"
        >
          <FaWhatsapp aria-hidden="true" /> WhatsApp
        </ShareLink>
        <CopiedNote role="status" aria-live="polite">{status}</CopiedNote>
      </ShareRow>
    </ShareBox>
  );
};

export default PromoterShareLinks;
